// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import { connect } from 'react-redux';
import LoginPageComponent from 'components/login-page/login-page';
import { CombinedState } from 'reducers/interfaces';
import { loginAsync } from 'actions/auth-actions';
import { GOOGLE_AUTH_URL } from '../../utils/oauth'

const goToGoogleLogin = () => {
    // const { url, params, redirect_uri, client_id } = consts.GOOGLE_AUTH
    // const googleAuthUrl = createGoogleAuthUrl(url, params, redirect_uri, client_id)
    // location.href = googleAuthUrl
    location.href = GOOGLE_AUTH_URL
}

interface StateToProps {
    fetching: boolean;
    renderResetPassword: boolean;
}

interface DispatchToProps {
    onLogin: typeof loginAsync;
    onClick: typeof goToGoogleLogin
}

function mapStateToProps(state: CombinedState): StateToProps {
    return {
        fetching: state.auth.fetching,
        renderResetPassword: state.auth.allowResetPassword,
    };
}

const mapDispatchToProps: DispatchToProps = {
    onLogin: loginAsync,
    onClick: goToGoogleLogin
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginPageComponent);
